import { useEffect } from 'react';
import { formatDateBody } from '../../../../../utils/FormatDate';
import useHttp from '../../../../hooks/use-http';
import DragAndDrop from '../../../UI/DragAndDrop';
import DecimalInput from '../../../UI/FormControls/DecimalInput';
import OInput from '../../../UI/FormControls/OInput';
import OAutocomplete from '../../../UI/MuiAutocomplete';
import { urls } from '../api/urls';
import TextArea from '../../../UI/FormControls/TextArea';
import MyButton from '../../../UI/myButton/MyButton';

const sledeciBrojPonude = {
  url: urls.GET_SL_BROJ_PONUDE,
};

const Inputs = ({ formValue, setFormValue, naziv, setNaziv, downloadFile }) => {
  const { sendRequest: vratiMasine, data: masineData } = useHttp('');
  const { data: broj } = useHttp(sledeciBrojPonude);
  useEffect(() => {
    const configMasine = {
      url: urls.GET_MASINE_COMBO,
    };
    vratiMasine(configMasine);
  }, []);

  const handleClickMasina = (item) => {
    setFormValue((curr) => {
      return { ...curr, idMasine: item.id, nazivMasine: item.vrednost };
    });
  };

  const handleChange = (e, name = null) => {
    let newFormData = {};
    if (e.value !== undefined && name !== null) {
      setFormValue((curr) => {
        return { ...curr, [name]: e.value };
      });
      return;
    }
    if (typeof formValue[e.target.name] === 'boolean') {
      newFormData = {
        ...formValue,
        [e.target.name]: e.target.checked,
      };
    } else {
      newFormData = {
        ...formValue,
        [e.target.name]: e.target.value,
      };
    }
    setFormValue(newFormData);
  };

  const handleFiles = (files) => {
    setFormValue((curr) => {
      return { ...curr, files: files };
    });
    setNaziv('');

    setFormValue((curr) => {
      return { ...curr, files: files };
    });
  };

  const handleUkloni = () => {
    setFormValue((curr) => {
      return { ...curr, files: [] };
    });
  };
  return (
    <div>
      <div style={{ marginTop: '10px' }}>
        <OInput
          label="Broj dokumenta"
          name="brojDokumenta"
          value={formValue.ceoBrDok !== '' ? formValue.ceoBrDok : broj.slBrDok}
          readonly
          style={{ width: '100%' }}
        />
      </div>
      {formValue.brZahteva !== '' && (
        <div style={{ marginTop: '10px' }}>
          <OInput
            label="Broj dokumenta"
            name="brZahteva"
            value={formValue.brZahteva}
            readonly
            style={{ width: '100%' }}
            disabled
          />
        </div>
      )}
      <div style={{ marginTop: '10px' }}>
        <OInput
          label="Datum"
          type="date"
          name="datum"
          value={formatDateBody(formValue.datum)}
          handleChange={handleChange}
          touched={formValue.touchedDatum}
          setTouched={() => {
            setFormValue((curr) => {
              return { ...curr, touchedDatum: true };
            });
          }}
          errorMessage="Datum je obavrezno polje"
          style={{ width: '100%' }}
        />
      </div>
      <div style={{ marginTop: '10px' }}>
        <OAutocomplete
          data={masineData}
          value={formValue.nazivMasine}
          handleClick={handleClickMasina}
          label="Robot/Alat"
          style={{ width: '100%' }}
        />
      </div>
      <div style={{ marginTop: '10px' }}>
        <DecimalInput
          handleChange={(e) => handleChange(e, 'ukupanIznos')}
          label="Ukupan iznos"
          value={formValue.ukupanIznos}
          name="ukupanIznos"
          style={{ width: '100%' }}
        />
      </div>
      <div style={{ marginTop: '10px' }}>
        <TextArea
          label="Napomena"
          type="text"
          value={formValue.napomena}
          name="napomena"
          rows="3"
          style={{ width: '100%' }}
          handleChange={handleChange}
        />
      </div>

      <div style={{ marginTop: '10px' }}>
        <DragAndDrop handleFiles={handleFiles} maxFiles={1} />
        {naziv !== null && naziv !== '' && formValue.files.length !== 0 && (
          <div
            style={{
              border: '1px solid gray',

              marginTop: '10px',
              padding: '5px',
            }}
          >
            <span
              style={{
                marginBottom: '0px',
                fontSize: '14px',
                fontWeight: '600',
                color: 'black',
              }}
            >
              Dodat fajl
            </span>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span style={{ color: 'black', fontSize: '14px' }}>
                {naziv !== null && naziv !== '' && naziv}
              </span>{' '}
              <div>
                <MyButton
                  onClick={(e) => {
                    e.stopPropagation();
                    downloadFile(e.fileName, e.idReda);
                  }}
                  label="Preuzmi"
                  icon="fas fa-download"
                  style={{ height: '35px' }}
                />
                <MyButton
                  onClick={handleUkloni}
                  label="Ukloni"
                  icon="fas fa-trash"
                  style={{ height: '35px' }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Inputs;
